// eslint-disable-next-line
import React, { useContext, useEffect, useState } from "react";
import UserContext from "../context/context";
import summaryApi from "../common/Api";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Loading from "../components/loading/loading";
import LogOutPage from "./LogOutPage";

const UserProfile = () => {
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const context = useContext(UserContext);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        const tokenApi = Cookies.get("tokenApi");
        if (!tokenApi) {
          // throw new Error("No token found");
          toast.error("Please login first");
        }
        const response = await axios.get(summaryApi.currentUser.url, {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
          },
          withCredentials: true,
        });
        // console.log("from UserProfile", response.data.user);
        setUserDetails(response.data?.user);
      } catch (error) {
        console.error("Error fetching user details:", error);
        setError(
          error instanceof Error
            ? error
            : new Error("An unknown error occurred")
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
    context.fetchUserDetails();
  },[]);

  return (
    <>
      <div className="flex items-center justify-center min-h-full mt-16 m-[15px] ">
        {loading && <Loading />}
        {/* {error && <p className="text-red-500">{error.message}</p>} */}
        {!loading && !error && (
          <div className="w-full max-w-5xl bg-white p-10 shadow-lg rounded-lg ">
            <h2
              style={{ fontFamily: "serif" }}
              className="text-3xl font-bold text-center mb-8 text-gray-800 "
            >
              User Profile
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  placeholder="Enter Your Email"
                  value={userDetails?.email || ""}
                  readOnly
                  className="w-full p-3 border rounded-md bg-gray-100 focus:outline-none"
                />
              </div>
              {/* Username */}
              <div>
                <label className="block text-gray-700 mb-1">User Name</label>
                <input
                  type="text"
                  placeholder="Enter Your User Name"
                  value={userDetails?.username || ""}
                  readOnly
                  className="w-full p-3 border rounded-md bg-gray-100 focus:outline-none"
                />
              </div>
              {/* Password */}
              <div>
                <label className="block text-gray-700 mb-1">Password</label>
                <input
                  type="password"
                  placeholder="Enter Your Password"
                  value="********"
                  readOnly
                  className="w-full p-3 border rounded-md bg-gray-100 focus:outline-none"
                />
              </div>
              {/* Password Confirmation */}
              <div>
                <label className="block text-gray-700 mb-1">
                  Password Confirmation
                </label>
                <input
                  type="password"
                  placeholder="Confirm Your Password"
                  value="********"
                  readOnly
                  className="w-full p-3 border rounded-md bg-gray-100 focus:outline-none"
                />
              </div>
            </div>
            {/* Logout Button */}
            <div className="mt-8 flex justify-left">
              <LogOutPage />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserProfile;
